import "./formGift.scss";
import { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Spin,
  notification,
} from "antd";
import { FormLayout } from "../../../../../layouts";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../../../helpers/withRouter";
import {
  getFormPromise,
  updateFormBasicPromise,
  sendFormPromise,
} from "../../../promises";
import { validateRutHelper } from "../../../../../helpers";
import Logo from "../../../../../layouts/commonComponent/components/Logo/Logo";
import moment from "moment";
import useFormsHooks from "../../hooks/useFormsHooks";
import { getOptList } from "../assets/optList";

const FormGift = ({ form, match, formId }) => {
  const { t, i18n } = useTranslation("forms");
  const optList = getOptList()

  const { getFieldsError, validateFields, setFieldsValue } = form;
  const [hasValidateMsg, setHasValidateMsg] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [colLogo, setColLogo] = useState(4);

  const [date, setDate] = useState(0);
  const [userId, setUserId] = useState("");
  const [subclienteId, setSubclienteId] = useState("0");
  const [apiForm, _setApiForm] = useState(null);
  const [format, setFormat] = useState("html");
  const [sentErrors, setSentErrors] = useState(0);
  const apiFormRef = useRef(apiForm);

  const setApiForm = data => {
    apiFormRef.current = data;
    _setApiForm(data);
  };

  const initVariablesFromObject = (obj, objs={}) => {
    let objs1 = {...objs}
    if (obj.json) {
      if (obj.json.baseParams) {
        let bParam = objToVariable(baseParamsIS, obj.json.baseParams);
        objs1['baseParams'] = bParam
      }
    }
    registerObjSections(objs1)
  };

  const handlerOnChangeObjAttr = async (sectionId, value, formObj) => {
    handleOnChangeField(sectionId, value)
    const binfo = entriesToObj(baseParams)

    if(!formObj) formObj = apiForm
    const json = { 
      baseParams: binfo,
    }
    let formToUpdate = { ...formObj, json };
    let ret = await saveFormPromiseLocal(formToUpdate);
    if(!ret.success) {
    }
  }

  const {
    getObjSection, 
    registerObjSections,  
    handleOnChangeField, 
    renderFormItemObj, 
    objToVariable, 
    entriesToObj, 
    sendDocument,
    saveFormPromiseLocal, 
  } = useFormsHooks({
    format,
    form,
    match,
    apiForm,
    setApiForm,
    handlerOnChangeObjAttr,
    initVariablesFromObject,
    optList
  });
  

  const baseParamsIS = {
    nombre: {key:'nombre', maxLength:100, title:t("forms.label.nombre"), id:'baseParamsNombre',readOnly:true,disabled:true,type:'input'},
    rut: {key:'rut', maxLength:100, title:t("forms.label.doc"), id:'baseParamsRut',readOnly:true,disabled:true,type:'input'},
    empresa: {key:'empresa', maxLength:100, title:t("forms.label.empresa"), id:'baseParamsEmpresa',readOnly:true,disabled:true,type:'input'},
    gerencia: {key:'gerencia', maxLength:100, title:t("forms.label.gerencia"), id:'baseParamsGerencia',readOnly:true,type:'input'},
    cargo: {key:'cargo',maxLength:100,title: t("forms.label.cargo"), id:'baseParamsCargo',readOnly:true,type:'input'},
    jefatura: {key:'jefatura',title: t("forms.label.nombreJefatura"), maxLength:100, id:'baseParamsJefatura',readOnly:true,type:'input'},
    mailJefatura: {key:'mailJefatura',maxLength:100, title:t("forms.label.correoJefatura"), id:'baseParamsMailJefatura',readOnly:true,type:'input'},
    giftType: {key:'giftType', id:'baseParamsGiftType',title: t("forms.label.tipo"),readOnly:true,type:'select'},
    organism: {key:'organism',maxLength:100, title: t("forms.label.empresa"), id:'baseParamsOrganism',readOnly:true,type:'input'},
    giftCategory: {key:'giftCategory',title:t("forms.label.categoria"), id:'baseParamsGiftCategory',readOnly:true,type:'select'},
    value: {key:'value',maxLength:10, title: t("forms.label.valorEstimado"), id:'baseParamsValue',readOnly:true,type:'input'},
    anomalies: {key:'anomalies',title: t("forms.label.comentariosAdicionales"),maxLength:4000 , id:'baseParamsAnomalies',readOnly:true,type:'textArea', required: false},
    reason:{key:'reason',maxLength:100, title: t("forms.label.motivo"), id:'baseParamsReason',readOnly:true,type:'input'},
    date:{key:'date', title:t("forms.label.fechaRecepcion"), id:'baseParamsDate',readOnly:true,type:'date'},
}

const [keyBaseParams, baseParams] = getObjSection('baseParams')


  function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
  }

  useEffect(() => {
    const obj = { baseParams: baseParamsIS }

    let idForm = formId ? formId : match.params.id;  

    setIsloading(true);
    getFormPromise(idForm).then((response) => {
      if (
        response.data !== null &&
        response.data !== "" &&
        response.data.status !== undefined
      ) {
        setApiForm(response.data);
        initVariablesFromObject(response.data, obj)
        setUserId(response.data.recipient.request.createUser.id);
        if (response.data.recipient.record.subcliente !== null) {
          setSubclienteId(response.data.recipient.record.subcliente.id);
        }
        if(response.data.status === "SENT") {
          setDate(moment(response.data.receiveDate).format("DD-MM-YYYY"));
        }else {
          setDate(moment().format("DD-MM-YYYY"));
        }
      }
      setIsloading(false);
      if (match.params.view === "pdf") {
        setColLogo(5);
        setFormat("pdf");
      }
    });
  }, [i18n.language]);

  const handleSubmit = async (e) => {
    let idForm = formId ? formId : match.params.id;  

    e.preventDefault();
    setHasValidateMsg(true);
    const y = validateFields();
    const x=getFieldsError()
    if (hasErrors(getFieldsError())) {
      notification["warning"]({
        message: t("messages.aml.missingRequiredField", {ns:'translations'}),
      });
    } else {
      sendDocument()
    }
  };

  const emailValidator = (rule, value, callback) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value && regex.test(value) === false) {
      callback("Debe ingresar un correo electrónico válido");
    } else {
      callback();
    }
  }

  return (
    <FormLayout view={match.params.view}>
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div className="form-header">
            <Row>
              <Col xs={9}></Col>
              <Col xs={6}>
                <div className="form-wrapper" style={{ textAlign: "center" }}>
                  <Spin style={{ fontColor: "#fff" }} size={"large"} />
                </div>
              </Col>
              <Col xs={9}></Col>
            </Row>
          </div>
        ) : (
          <>
            {apiForm !== null ? (
              <div
                className={
                  "form-content" +
                  (!hasValidateMsg ? " form-validate-messages" : "")
                }
              >
                <Row>
                  <Col>
                    <Form 
                      onSubmit={handleSubmit} 
                      className="form-form"
                    >
                      <Row
                        className="title-logo"
                        gutter={[0, 6]}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          marginTop: "0px",
                          marginBottom: "0px",
                          textAlign: "left",
                          paddingTop: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <Col
                          xs={24 - colLogo}
                          sm={24 - colLogo}
                          md={24 - colLogo}
                          lg={24 - colLogo}
                          xl={24 - colLogo}
                        >
                          {
                          format === "html" ?
                          <h3>
                            {t("forms.gift.title")}
                          </h3>
                          :
                          <h4>
                            {t("forms.gift.title")}
                          </h4>
                          }

                        </Col>
                        <Col
                          className="logo-col"
                          xs={colLogo}
                          sm={colLogo}
                          md={colLogo}
                          lg={colLogo}
                          xl={colLogo}
                        >
                          <Logo currentUser={{ userId, subclienteId }} isForm={true} />
                        </Col>
                      </Row>

                      <Row
                        className="date"
                        gutter={[0, 6]}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          marginTop: "0px",
                          marginBottom: "0px",
                          textAlign: "left",
                          paddingBottom: "15px",
                          paddingLeft: "10px",
                        }}
                      >
                        <Col span={2} style={{ textAlign: "left" }}>
                          {t("forms.label.fecha")}:
                        </Col>
                        <Col span={4}>
                          <div
                            className="formDate"
                            style={{
                              marginLeft: "5px",
                              borderStyle: "solid",
                              borderWidth: "1px",
                              borderColor: "#e8e8e8",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {date}
                          </div>
                        </Col>
                        <Col span={13} style={{ textAlign: "right" }}>
                          {t("forms.label.folio")}:
                        </Col>
                        <Col span={5}>
                          <div
                            className="formDate"
                            style={{
                              borderStyle: "solid",
                              borderWidth: "1px",
                              borderColor: "#e8e8e8",
                              display: "flex",
                              justifyContent: "center",
                              marginRight: "10px",
                              marginLeft: "8px",
                            }}
                          >
                            {apiForm.folio !== null ? apiForm.folio : ""}
                          </div>
                        </Col>
                      </Row>

                      {apiForm.status === "SENT" && format === "html" ? (
                        <>
                          <br />
                          <h3 style={{ textAlign: "center" }}>
                            {t("forms.messages.formWasSent1", {name: apiForm.recipient.record.nombre, ns: "forms"})}
                            <br />
                            {t("forms.messages.formWasSent2")}:<br/><br/>
                            {apiForm.recipient.record.email}
                          </h3>
                        </>
                      ) : (
                        <>
                          <Row
                            className="lineamiento subheader"
                            style={{ marginTop: "0px" }}
                          >
                            <Col xl={24}>{t("forms.titles.lineamiento")}</Col>
                          </Row>

                          <Row className="summary">
                            <Col xl={24}>
                              <p>
                                {t("forms.sonda.gift.lineamiento.text1", {ns:"formsSonda"})}
                              </p>
                              <p>
                                a. {t("forms.sonda.gift.lineamiento.text2", {ns:"formsSonda"})}:
                                  <ul>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text3", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text4", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text5", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text6", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text7", {ns:"formsSonda"})}
                                    </li>
                                  </ul>
                              </p>
                              <p>
                                b. {t("forms.sonda.gift.lineamiento.text8", {ns:"formsSonda"})}:
                                  <ul>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text9", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text10", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text11", {ns:"formsSonda"})}
                                    </li>
                                  </ul>
                              </p>
                              <p>
                                c. {t("forms.sonda.gift.lineamiento.text12", {ns:"formsSonda"})}:
                                  <ul>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text13", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text14", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text15", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text16", {ns:"formsSonda"})}
                                    </li>
                                    <li>
                                      {t("forms.sonda.gift.lineamiento.text17", {ns:"formsSonda"})}
                                    </li>
                                  </ul>
                              </p>
                          
                            </Col>
                          </Row>
                          <br/>
                          <Row
                            className="subheader"
                            style={{
                              marginTop: "0px",
                            }}
                          >
                            <Col xl={24}>{t("forms.titles.colaborador")}</Col>
                          </Row>

                          <Row className="content">
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                initialValue: apiForm.recipient.record.nombre,
                                section: baseParams.nombre,
                                disabled: true,
                                cols: 16,
                              })}

                              {renderFormItemObj({
                                initialValue: apiForm.recipient.record.rut,
                                section: baseParams.rut,
                                disabled: true,
                                cols: 8,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.empresa,
                                initialValue:
                                  apiForm.recipient.record.subcliente !== null
                                    ? apiForm.recipient.record.subcliente.name
                                    : apiForm.recipient.request.createUser
                                        .cliente.name,
                                disabled: true,
                                cols: 8,
                              })}
                              
                              {renderFormItemObj({
                                section: baseParams.gerencia,
                                cols: 8,
                              })}

                              {renderFormItemObj({
                                section: baseParams.cargo,
                                cols: 8,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.jefatura,
                                cols: 16,
                              })}

                              {renderFormItemObj({
                                section: baseParams.mailJefatura,
                                validator: emailValidator,
                                cols: 8,
                              })}
                            </Row>
                          </Row>

                          <Row className="subheader">
                            <Col xl={24}>{t("forms.titles.contenido")}</Col>
                          </Row>

                          <Row className="content" style={{ padding: "0px" }}>
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.giftType,
                                colClassName: "leftLabel",
                                cols: 24,
                                wrapperCol: 20,
                                labelCol: 4
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                               section: baseParams.organism,
                               colClassName: "leftLabel",
                               cols: 24,
                               wrapperCol: 20,
                               labelCol: 4,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.giftCategory,
                                colClassName: "leftLabel",
                                cols: 24,
                                wrapperCol: 20,
                                labelCol: 4
                              })}
                            </Row>

                            {apiForm.reunion !== null
                                    && apiForm.reunion.category === "Otros" &&(
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.reason,
                                initialValue: apiForm.reunion !== null ? apiForm.reunion.reason : null,
                                colClassName: "leftLabel",
                                cols: 24,
                                wrapperCol: 20,
                                labelCol: 4,
                              })}
                            </Row>

                                    )}

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.date,
                                initialValue:
                                  apiForm.reunion !== null
                                  && apiForm.reunion.date !== undefined
                                  && apiForm.reunion.date !== null
                                   ? format === 'html' ?
                                    moment(apiForm.reunion.date)
                                    : moment(apiForm.reunion.date).format('DD/MM/YYYY')
                                    : null,
                                colClassName: "leftLabel",
                                cols: 12,
                                labelCol: 8,
                                wrapperCol: 12,
                              })}


                              {renderFormItemObj({
                                section: baseParams.value,
                                initialValue:
                                apiForm.reunion !== null
                                  ? apiForm.reunion.value
                                  : null,
                                colClassName: "leftLabel",
                                cols: 12,
                                labelCol: 12,
                                wrapperCol: 12,
                              })}
                            </Row>

                            <br/>
                            <Row className="anomalies">
                              {renderFormItemObj({
                                section: baseParams.anomalies,
                                initialValue: apiForm.reunion!==null?apiForm.reunion.anomalies:null,
                                cols: 24,
                              })}
                            </Row>


                            {format === "html" && (
                              <Row className="button-row">
                                <Col className="submitTrabajador" xl={24}>
                                  <Button
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    {t("forms.buttons.send")}
                                  </Button>
                                </Col>
                              </Row>
                            )}
                          </Row>
                        </>
                      )}
                    </Form>
                  </Col>
                </Row>
              </div>
            ) : (
              <h2 style={{ textAlign: "center" }}>Formulario no encontrado</h2>
            )}
          </>
        )}
      </div>
    </FormLayout>
  );
};

export default withRouter(Form.create()(FormGift));
